module.exports = __webpack_public_path__ + "static/img/popup0117.b3259e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popup0117.png
// module id = qN45
// module chunks = 0